import React from "react";
import { Grid, Typography, Pagination, styled } from "@mui/material";
import { useShallowSelector } from "../../../../hooks/useShallowSelector";
import RootState from "../../../../redux/types/rootState";

interface PaginationProps {
  onPageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  classes: Record<string, string>;
}

const PaginationComponent: React.FC<PaginationProps> = ({
  onPageChange,
  classes,
}) => {
  const myPaginationGridClass = `${classes.paginationAndBookingCountGrid} myPaginationGrid`;

  const MyPaginationGrid = styled(Grid)(({ theme }) => ({
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "row",
    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
    },
  }));

  const bookingsResponse = useShallowSelector(
    (state: RootState) => state.bookings.bookingsResponse
  );

  const { pageCount, pageSize, totalRecordCount, currentPage } =
    bookingsResponse || {};
  const pSize = pageSize ? pageSize : 1;
  const cPage = currentPage ? currentPage : 1;
  const pageStart_s = pSize * (cPage - 1) + 1;
  const pageStart_e = totalRecordCount
    ? totalRecordCount > pSize * cPage - 1
      ? pSize * cPage - 1
      : totalRecordCount
    : pSize * cPage - 1;
  return (
    <Grid container item className={myPaginationGridClass}>
      <MyPaginationGrid
        item
        container
        xs={12}
        md={7}
        className="myPaginationGrid"
      >
        <Pagination
          count={pageCount}
          shape="rounded"
          color="primary"
          variant="outlined"
          page={currentPage}
          onChange={onPageChange}
        />
      </MyPaginationGrid>
      <Grid item container xs={12} md={5} className={classes.bookingCountGrid}>
        <Typography className={classes.bookingCountText}>
          {`Showing ${pageStart_s}-${pageStart_e} of ${totalRecordCount}`}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PaginationComponent;
